import React from 'react';
import FormWrapper from '../../../common/formComponents/FormWrapper/FormWrapper';
import useAddField from '../../../../../../hooks/useAddField';
import AddFieldsRow from '../../../common/formComponents/AddFieldsRow/AddFieldsRow';
import SelectFlat from '../common/SelectFlat';
import TreeSelectFlat from '../common/TreeSelectFlat';
import Block from './components/Block/Block';
import { texts } from '../../../../constants/texts';
import { TenantAutoEdit } from './components/TenantAutoEdit/TenantAutoEdit';
import { ShowAllTenantDocuments } from '../../../common/ShowAllTenantDocuments/ShowAllTenantDocuments';

const AddTenantForm = ({
  form,
  withSelectFlat,
  withSelectHouse = false,
  initialValues,
  addressId,
}) => {
  const {
    keys: tenantKeys,
    add: addTenantFields,
    remove: removeTenantsField,
  } = useAddField({
    form,
    name: 'tenantKeys',
    initialNumOfFields: 1,
  });

  return (
    <FormWrapper>
      {withSelectHouse && <TreeSelectFlat form={form} />}
      {withSelectFlat && <SelectFlat form={form} />}
      {tenantKeys.map((key, index) => (
        <Block
          key={`${key}-${index}`}
          fieldKey={key}
          index={index}
          initialValues={initialValues}
          onRemoveTenantField={removeTenantsField}
          form={form}
        />
      ))}
      {!initialValues && (
        <AddFieldsRow
          style={{ marginTop: '42px' }}
          withBorder
          text={texts.addTenant}
          rowType="field"
          addFieldsFunc={addTenantFields}
        />
      )}
      {/* {initialValues && addressId && (
        <TenantAutoEdit
          tenantId={initialValues.id}
          autoInfo={initialValues?.transports}
          empty={!initialValues?.transports?.length}
          addressId={addressId}
        />
      )} */}
      {initialValues && (
        <ShowAllTenantDocuments
          clientId={initialValues.id}
          text="Добавить документы"
        />
      )}
    </FormWrapper>
  );
};

export default AddTenantForm;
